<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../canadas/casas/maplocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
